
function getElementIndex(element) {
	return Array.from(element.parentNode.children).indexOf(element);
}

let supportsPassive = false;
try {
	const opts = Object.defineProperty({}, 'passive', {
		get: function () {
			supportsPassive = true;
		}
	});
	window.addEventListener('test', null, opts);
} catch (e) { }

// PRODCARD IMGS HOVER / SWIPE
function prodImgHover() {

	document.querySelectorAll('.js_prodpic:not(.isinit)').forEach(prodPic => {
		if (prodPic.querySelector('.js_prodpic_trigger')) {

			// init first
			// prodPic.querySelector('.js_prodpic_trigger').classList.add('m-active');
			// prodPic.querySelector('.js_prodpic_dot').classList.add('m-active');
			// prodPic.querySelector('.js_prodpic_img').classList.add('m-active');

			// mouse stuff
			prodPic.querySelectorAll('.js_prodpic_trigger').forEach(picTrigger => {
				picTrigger.addEventListener('mouseover', (e) => {
					const targetindex = getElementIndex(picTrigger);

					const thisPic = picTrigger.closest('.js_prodpic');

					// load pics
					thisPic.querySelectorAll('[loading="lazy"]').forEach(lazy => {
						lazy.removeAttribute('loading');
					});

					thisPic.querySelectorAll('.m-active').forEach(item => {
						item.classList.remove('m-active');
					});
					picTrigger.classList.add('m-active');

					thisPic.querySelectorAll('.js_prodpic_dot')[targetindex].classList.add('m-active');
					thisPic.querySelectorAll('.js_prodpic_img')[targetindex].classList.add('m-active');

				});
			});

			// touch stuff
			prodPic.querySelectorAll('.js_prodpic_triggers').forEach(picTriggers => {
				let touchstartX = 0;
				let touchendX = 0;
				const thisPic = picTriggers.closest('.js_prodpic');

				picTriggers.addEventListener('touchstart', (e) => {
					touchstartX = e.changedTouches[0].screenX;
					// console.log(touchstartX);

					// load pics
					thisPic.querySelectorAll('[loading="lazy"]').forEach(lazy => {
						lazy.removeAttribute('loading');
					});
				}, { passive: supportsPassive ? true : false });
				picTriggers.addEventListener('touchend', (e) => {
					touchendX = e.changedTouches[0].screenX;
					// console.log(touchendX);


					if (touchendX > touchstartX) {
						const currentPrev = thisPic.querySelector('.js_prodpic_trigger.m-active').previousElementSibling;
						if (currentPrev) {
							swipePic(currentPrev, thisPic);
						}
					}
					if (touchendX < touchstartX) {
						const currentNext = thisPic.querySelector('.js_prodpic_trigger.m-active').nextElementSibling;
						if (currentNext) {
							swipePic(currentNext, thisPic);
						}
					}

					function swipePic(currentTrigger, thisPic) {
						thisPic.querySelectorAll('.m-active').forEach(item => {
							item.classList.remove('m-active');
						});
						currentTrigger.classList.add('m-active');
						const targetindex = getElementIndex(currentTrigger);
						thisPic.querySelectorAll('.js_prodpic_dot')[targetindex].classList.add('m-active');
						thisPic.querySelectorAll('.js_prodpic_img')[targetindex].classList.add('m-active');
					}
				});
			})
		}
		prodPic.classList.add('isinit');
	});

}

document.addEventListener('DOMContentLoaded', function () {


	// USER'S SCROLLS, SWIPES AND STUFF
	let isTouchCursor = false;

	document.body.addEventListener('touchstart', (e) => {
		document.body.classList.add('touchable');
		document.querySelectorAll('.js_prodpic_triggers').forEach(item => {
			item.classList.add('swiper-no-swiping');
		});
	})
	document.addEventListener('mousemove', function (e) {
		if (!isTouchCursor) {
			document.body.classList.add('mousable');
		}
	});

	// hold on touch events
	let touchTimeout;
	document.body.addEventListener('touchstart', (e) => {
		clearTimeout(touchTimeout);
		isTouchCursor = true;
		touchTimeout = setTimeout(() => {
			isTouchCursor = false;
		}, 500);
	});

	prodImgHover();
	// ========================================

});